module.exports = __webpack_public_path__ + "img/ship.c4d4b25e.svg";